<!-- 采购收货数据操作 -->
<template>
    <div>
        <subComponents ref="showSelectData"></subComponents>
        <procurementOrderTemplate ref="procurementOrderTemplate" @selectDataAction="selectDataAction">
        </procurementOrderTemplate>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form label-width="100px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                        <el-row slot="" v-if="dataActionBox.actionType != 2">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item v-if="formOneValue.isShow == 1" :key="formOneKey" :label="formOneValue.showField" :prop="formOneValue.entityField"
                                                              :rules="formOneValue.isRequired == 1 ? [{ required: formOneValue.isChange == 1, trigger: ['blur', 'change'] }] : []">
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                    <el-tooltip v-if="formOneValue.fieldType == 'search'" class="item"
                                                                :disabled="sendDataInfo[formOneValue.entityField]==null||sendDataInfo[formOneValue.entityField]==''?true:false || sendDataInfo[formOneValue.entityField].length<=9"
                                                                effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                        <el-input class="form_codition" v-if="formOneValue.fieldType == 'search'" clearable v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField"
                                                                  :id="formOneValue.entityField" @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                                  :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1">
                                                            <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                       :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 1">
                                                            </el-button>
                                                        </el-input>
                                                    </el-tooltip>
                                                    <df-date class="form_codition" v-else-if="formOneValue.fieldType == 'date'" @keyup.enter.native="nextFocus(formOneKey)" :isShowLong="false"
                                                             :isdisabled="formOneValue.isChange == 0" v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                                    <!-- formatter下拉选   :automatic-dropdown="true"-->
                                                    <el-select class="form_codition" clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" @visible-change="selectChange"
                                                               :disabled="formOneValue.isChange == 0 || (sendDataInfo.pisOrderDetail.length > 0 && formOneValue.isUpdate == 0)" @change="$forceUpdate()"
                                                               v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                        <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.key" :value="item.value">
                                                        </el-option>
                                                    </el-select>

                                                    <el-input class="form_codition" type="number"
                                                              v-else-if="formOneValue.entityField == 'saiTelnumber' || formOneValue.entityField == 'saiPostcode' || formOneValue.entityField == 'credit'"
                                                              :disabled="formOneValue.isChange == 0" @keyup.enter.native="nextFocus(formOneKey)" v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                                    <el-input class="form_codition" v-else :disabled="formOneValue.isChange == 0" @keyup.enter.native="nextFocus(formOneKey)"
                                                              v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item :label="formOneValue.showField + ':'" :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1" :key="formOneKey">
                                                    <span v-if="formOneValue.fieldType == 'date'">
                                                        {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField])
                                                    }}</span>
                                                    <span v-else-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{
                                                        sendDataInfo[formOneValue.entityField] }}</a>
                                                    </span>
                                                    <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                    </el-form>
                                    <!-- 明细    -->
                                    <el-form size="mini" v-if="sendDataInfo.pisOrderDetail">
                                        <div style="margin-bottom:10px" id="operateBtn" v-if="dataActionBox.actionType != 2">
                                            <el-button type="primary" size="mini" @click="addDetail('sendDataInfo')" v-if="ppIds != 'psomId'">
                                                新增</el-button>
                                            <el-button type="primary" size="mini" @click="deleteDetails()" v-if="ppIds != 'psomId'">删除</el-button>
                                            <el-button @click="openExComponents('629899519725569')" size="mini" type="primary" v-if="ppIds != 'psomId'">提取外部订单</el-button>
                                            <el-button @click="openExComponents('3405885795012608')" size="mini" type="primary">提取采购订单</el-button>
                                            <el-button @click="saveDraft()" size="mini" type="primary">保存草稿</el-button>
                                            <el-button @click="draft()" size="mini" type="primary">提取草稿</el-button>
                                            <el-button @click="resetData" size="mini" type="primary">重置</el-button>
                                            <el-button @click="exportTemplate" size="mini" type="primary">下载模版</el-button>
                                            <el-button @click="importDetails" size="mini" type="primary">导入明细</el-button>
                                            <el-button @click="matchingClick" size="mini" type="primary">匹配</el-button>
                                        </div>
                                        <el-table :key="tableIndex" size="mini" ref="mxTableRef" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent" @selection-change="handleSelectionChange"
                                                  :data="sendDataInfo.pisOrderDetail" border style="width: 100%" :height="mxHeight">
                                            <el-table-column width="80" label="选择操作" v-if="dataActionBox.actionType != 2 && ppIds != 'psomId'">
                                                <template slot-scope="scope">
                                                    <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                                        <i class="el-icon-thumb"></i>
                                                    </el-radio>
                                                </template>
                                            </el-table-column>
                                            <template v-for="(formOneValue, formOneKey) in mxForm.jurconfigform">
                                                <el-table-column :min-width="formOneValue.fieldWeight" align="center" show-overflow-tooltip :prop="formOneValue.entityField" :label="formOneValue.showField"
                                                                 :key="formOneKey" v-if="formOneValue.isShow == 1">
                                                    <template slot-scope="scope">
                                                        <!-- 显示通用名称 -->
                                                        <span v-if="formOneValue.isRift == 1">
                                                            <a @click="toDetail(scope.row[formOneValue.riftField])">{{
                                                                scope.row[formOneValue.entityField] }}</a>
                                                        </span>

                                                        <el-input @mousewheel.native.prevent :ref="formOneValue.entityField" @clear="clearBatchno(scope.$index)"
                                                                  v-else-if="formOneValue.entityField == 'batchno'&&scope.row.batchnoList&&scope.row.batchnoList.length>0&&dataActionBox.actionType != 2" clearable
                                                                  @keyup.enter.native="openSearchs(scope.row.batchnoList,scope.$index)" v-model="scope.row[formOneValue.entityField]">
                                                            <el-button @click="openSearchs(scope.row.batchnoList,scope.$index)" slot="append" icon="el-icon-search"></el-button>
                                                        </el-input>
                                                        <!-- 显示通用名称 -->
                                                        <el-input @mousewheel.native.prevent :ref="formOneValue.entityField" v-else-if="formOneValue.fieldType == 'search'
                                                                && dataActionBox.actionType != 2 && formOneValue.isChange == 1" clearable
                                                                  @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField, true)"
                                                                  v-model="scope.row[formOneValue.entityField]">
                                                            <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, formOneValue.setField, formOneValue.focusField, true)"
                                                                       slot="append" icon="el-icon-search"></el-button>
                                                        </el-input>
                                                        <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField"
                                                                  v-else-if="formOneValue.entityField == 'psodPacknum'&& dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                                  @change="calculatePrice(5, scope.$index)" type="number" v-model="scope.row[formOneValue.entityField]"></el-input>
                                                        <!-- 含税价格 -->
                                                        <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" type="number"
                                                                  v-else-if="formOneValue.entityField == 'psprice'
                                                                && dataActionBox.actionType != 2 && formOneValue.isChange == 1" :disabled="scope.row.psodPacknum <= 0" @input="calculatePrice(2, scope.$index)"
                                                                  v-model="scope.row[formOneValue.entityField]">
                                                        </el-input>
                                                        <!-- 单价 -->
                                                        <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" v-else-if="formOneValue.entityField == 'price'
                                                                && dataActionBox.actionType != 2 && formOneValue.isChange == 1" type="number" :disabled="scope.row.psodPacknum <= 0"
                                                                  @input="calculatePrice(1, scope.$index)" v-model="scope.row[formOneValue.entityField]">
                                                        </el-input>
                                                        <!-- 总金额 -->
                                                        <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" type="number"
                                                                  v-else-if="formOneValue.entityField == 'money'
                                                                && dataActionBox.actionType != 2 && formOneValue.isChange == 1" :disabled="scope.row.psodPacknum <= 0" @input="calculatePrice(3, scope.$index)"
                                                                  v-model="scope.row[formOneValue.entityField]">
                                                        </el-input>

                                                        <!-- 含税金额 -->
                                                        <el-input @mousewheel.native.prevent v-else-if="formOneValue.entityField == 'psmoney'
                                                                && dataActionBox.actionType != 2 && formOneValue.isChange == 1" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                                  :ref="formOneValue.entityField" type="number" :disabled="scope.row.psodPacknum <= 0" @input="calculatePrice(4, scope.$index)"
                                                                  v-model="scope.row[formOneValue.entityField]">
                                                        </el-input>
                                                        <!-- 生产日期 -->
                                                        <df-date :isType="true" :isShowLong="formOneValue.entityField == 'expidate' ? true : false"
                                                                 v-else-if="formOneValue.fieldType == 'date' && dataActionBox.actionType != 2" :ref="formOneValue.entityField" :class="formOneValue.entityField"
                                                                 :isLongTime="formOneValue.entityField == 'expidate' ? true : false" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                                 v-model="scope.row[formOneValue.entityField]">
                                                        </df-date>
                                                        <!-- <df-date :isType="true" :isShowLong="formOneValue.entityField == 'expidate' ? true : false"
                                                                 v-else-if="formOneValue.fieldType == 'date' && dataActionBox.actionType != 2"
                                                                 :isdisabled="scope.row.batchnoList&&scope.row.batchnoList.length>0?true:false" :ref="formOneValue.entityField" :class="formOneValue.entityField"
                                                                 :isLongTime="formOneValue.entityField == 'expidate' ? true : false" @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)"
                                                                 v-model="scope.row[formOneValue.entityField]">
                                                        </df-date> -->
                                                        <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField"
                                                                  v-else-if="dataActionBox.actionType != 2 && formOneValue.isChange == 1" v-model.trim="scope.row[formOneValue.entityField]">
                                                        </el-input>
                                                        <span v-else-if="formOneValue.fieldType == 'date'">
                                                            {{$common.getLocalTime(sendDataInfo[formOneValue.entityField])}}
                                                        </span>
                                                        <span v-else>
                                                            {{scope.row[formOneValue.entityField]}}
                                                        </span>
                                                    </template>
                                                </el-table-column>
                                            </template>
                                        </el-table>
                                    </el-form>
                                </div>
                                <!-- 冷链信息 -->
                                <div v-if="scope.index == 1">
                                    <el-form size="mini" id="coldInfo" :disabled="dataActionBox.actionType == 2" class="baseForm" label-width="150px" v-if="sendDataInfo.pisRegoCtri" :show-message="false">
                                        <el-row>
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item :key="formOneKey" :label="formOneValue.showField" v-if="formOneValue.isShow == 1"
                                                              :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                                    <!-- 系统字段 -->
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                    <div v-if="formOneValue.isReserved == 0">
                                                        <el-date-picker class="form_codition" :disabled="formOneValue.isChange == 0" @change="timeBlur(formOneKey)" v-if="formOneValue.fieldType == 'date'"
                                                                        v-model="sendDataInfo.pisRegoCtri[formOneValue.entityField]" type="datetime" placeholder="选择日期" value-format="timestamp">
                                                        </el-date-picker>
                                                        <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                                                    :disabled="sendDataInfo.pisRegoCtri[formOneValue.entityField]==null||sendDataInfo.pisRegoCtri[formOneValue.entityField]==''?true:false || sendDataInfo.pisRegoCtri[formOneValue.entityField].length<=9"
                                                                    effect="dark" :content="sendDataInfo.pisRegoCtri[formOneValue.entityField]" placement="bottom-start">
                                                            <el-input class="form_codition" clearable v-model="sendDataInfo.pisRegoCtri[formOneValue.entityField]" :ref="formOneValue.entityField"
                                                                      :id="formOneValue.entityField" @keyup.enter.native="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)"
                                                                      :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                                <el-button @click="openSearch(formOneValue.searchId, formOneKey, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                           :disabled="formOneValue.isChange == 0 || dataActionBox.actionType == 2">
                                                                </el-button>
                                                            </el-input>
                                                        </el-tooltip>
                                                        <el-input class="form_codition" v-else @keyup.enter.native="nextFocus(formOneKey)" v-model.trim="sendDataInfo.pisRegoCtri[formOneValue.entityField]"
                                                                  maxlength="$store.state.inputLength"></el-input>
                                                    </div>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                    </el-form>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :btnFlag="true" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction"
                        @showPrintPlan="showPrintPlan"></v-foot>
            </div>
            <el-dialog title="提示" v-if="showDialog" :visible.sync="showDialog" width="70%" :modal-append-to-body="true" :append-to-body="true">
                <el-table :data="dialogList" border style="width: 100%">
                    <el-table-column prop="level" label="类型" width="50">
                        <template slot-scope="{row}">
                            <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                                {{ row.level == 0 ? "拦截" : '预警' }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="data" label="内容" min-width="180">
                    </el-table-column>
                    <el-table-column prop="validity" label="有效期" min-width="100">
                        <template slot-scope="{row}">
                            {{ $common.getLocalTime(row.validity) }}
                        </template>
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button size="mini" type="primary" @click="showDialog = false">确 定</el-button>
                </span>
            </el-dialog>
            <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
                <ExtractionScheme ref="extractionScheme" :ppId="ppId" :id="exId" @TranData="getExData" @getWidth="getExWidth" @sendTitle="getExtractName" />
            </el-dialog>
            <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
                <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
            </el-dialog>
            <!-- 草稿保存弹窗 -->
            <el-dialog title="保存草稿" :visible.sync="draftDialogVisible" width="500px" :modal-append-to-body="true" :append-to-body="true">
                <el-form ref="draftForm" :model="draftForm" label-width="80px">
                    <el-form-item label="备注" prop="remark">
                        <el-input v-model="draftForm.remark" type="textarea" :rows="4" placeholder="请输入草稿备注信息" maxlength="200" show-word-limit>
                        </el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="draftDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="confirmSaveDraft">确 定</el-button>
                </span>
            </el-dialog>

            <!-- 草稿列表弹窗 -->
            <el-dialog title="提取草稿" :visible.sync="draftListDialogVisible" width="80%" :modal-append-to-body="true" :append-to-body="true">
                <div style="margin-bottom: 15px;">
                    <el-button type="primary" size="small" @click="loadDraftList" :loading="loadingDraftList">
                        <i class="el-icon-refresh"></i> 刷新
                    </el-button>
                </div>

                <el-table :data="draftList" border style="width: 100%" height="400" v-loading="loadingDraftList" @row-click="onDraftRowClick" highlight-current-row :row-class-name="getDraftRowClassName">

                    <el-table-column prop="remark" label="备注" min-width="200" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="createrName" label="创建人" min-width="200" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建时间" width="180" align="center">
                        <template slot-scope="scope">
                            {{ $common.getLocalTime(scope.row.createTime,true) }}
                        </template>
                    </el-table-column>

                    <el-table-column prop="modelType" label="模块类型" width="120" align="center">
                    </el-table-column>

                    <el-table-column label="操作" width="150" align="center">
                        <template slot-scope="scope">
                            <el-button type="primary" size="mini" @click.stop="loadDraft(scope.row)">
                                确认选择
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="draftListDialogVisible = false">关 闭</el-button>
                </span>
            </el-dialog>
            <el-dialog title="批号信息" :visible.sync="batchnoShow" width="1000px" :modal-append-to-body="true" :append-to-body="true">
                <BatchnoSearch v-if="batchnoShow" ref="batchnoSearch" :selectDataList="selectDataList" :dataList="dataList" :batchnoList="batchnoList" @TranData="TranData" />
            </el-dialog>
            <el-dialog title="导入" :visible.sync="importShow" width="30%" append-to-body modal-append-to-body>
                <initDataUpload :url="url" :errorUrl="'pisplanorder/exportStepPisFail'" :listShow="true" :importType="importType" @fileSuccess='fileSuccess' @closeExcel="closeExcel" :parentSearchData="importObj">
                </initDataUpload>
            </el-dialog>
            <printPlan ref="printPlan"></printPlan>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
import SearchScheme from "../byComponents/SearchScheme.vue";
// import SearchScheme from "../byComponents/SearchScheme.vue";
import procurementOrderTemplate from "@/components/procurementOrderTemplate.vue";
import BatchnoSearch from "@/components/batchnoSearch.vue";
import NP from "number-precision";
export default {
    name: "puOnStorageAction",
    props: ['actionData'],
    //import引入的组件需要注入到对象中才能使用
    components: {
        ExtractionScheme,
        SearchScheme,
        procurementOrderTemplate,
        BatchnoSearch,
    },
    data() {
        //这里存放数据
        return {
            tableIndex: 0,
            showDialog: false,
            detailsFlag: false,
            dialogList: [],
            draftDialogVisible: false,
            draftForm: {
                remark: ""
            },
            draftListDialogVisible: false,
            draftList: [],
            selectedDraftIndex: -1,
            loadingDraftList: false,
            ppId: "orderId",
            ppIds: "orderId",
            selectedDetailsIndex: 0,
            exTitle: "",
            exWidth: "90%",
            exId: "",
            DialogExtract: false,
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {},
            showTabs: "",
            formDataList: [],
            dictionariesData: {},
            userOneList: [],
            salesmanList: [],
            mxHeight: 0,
            isLoaded: false,
            selectedRow: [], // 当前已选择行
            mainFormList: [], //过滤的主表单
            tabForm: [], // tab循环的主表单
            mxForm: [],
            footForm: [],
            sField: '', // 赋值字段
            fField: '', //焦点字段
            nosField: '', // 不可赋值字段
            inputel: '', //所有input对象
            seTitle: "", //检索
            DialogVisible: false,
            seId: 0,
            seType: "",
            seIndex: 0,
            seWidth: '',
            parentSearchData: {},
            detaislDataInfo: {
                "batchno": "",
                "bgiType": "",
                "bgmId": 0,
                bgmName: '',
                "expidate": '',
                "inRate": 0,
                "lastPuprice": 0,
                "lowestPrice": 0,
                "money": 0,
                "pieceNum": 0,
                "price": 0,
                "prodate": '',
                "psmoney": 0,
                "psodPacknum": 0,
                "psodPsdvolume": 0,
                "psodPslowerlimit": 0,
                "psodPsnvolume": 0,
                "psodPsupperlimit": 0,
                "psomId": "",
                "pspdId": 0,
                "psprice": 0,
                "scatNum": 0,
                "stId": 0,
                stName: '',
                "sterBatchno": "",
                "taxAmount": 0,
                "wholeNum": 0,
                expidate: "",
                prodate: "",
                wesCodeList: [],
                batchnoList: []
            },
            newDayTime: '',
            newTime: "",
            //---------
            importShow: false,
            importType: "",
            url: "",
            //-------------
            batchnoShow: false,
            batchnoList: [],
            dataList: [],
            selectDataList: [],
            importObj: {
                formId: '',
                salesId: '',
                unitId: '',
            },
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.pisOrderDetail": {
            handler: function (newValue, oldValue) {
                this.sendDataInfo.totalNumber = 0;
                this.sendDataInfo.totalMoney = 0;

                let totalMoney = 0;
                let totalNumber = 0;
                console.log(this.sendDataInfo.pisOrderDetail, "测试123");

                // 单次遍历处理所有订单明细，提高性能
                this.sendDataInfo.pisOrderDetail.forEach((item, keys) => {
                    // if (item.batchno == "" && item.batchnoList && item.batchnoList.length > 0) {
                    //     item.prodate = ""
                    //     item.expidate = ""
                    //     item.wesCodeList = []
                    // }
                    // 批量更新数字字段（假设updataNum可以接受数组参数，否则保留原方式）
                    const updatedPacknum = this.$common.updataNum('psodPacknum', item).psodPacknum;
                    const updatedPrice = this.$common.updataNum('psprice', item).psprice;
                    const updatedPsmoney = this.$common.updataNum('psmoney', item).psmoney;

                    this.$set(item, 'psodPacknum', updatedPacknum);
                    this.$set(item, 'psprice', updatedPrice);
                    this.$set(item, 'psmoney', updatedPsmoney);

                    // 检查生产日期
                    if ((item.prodate > this.newTime) && item.prodate != '' && item.prodate != 0.5) {
                        item.prodate = "";
                        if (this.$refs.prodate && this.$refs.prodate[keys]) {
                            this.$refs.prodate[keys].$forceUpdate();
                        }
                        this.$message({
                            message: "生产日期不能大于今日",
                            type: "warning",
                        });
                    }

                    // 检查失效日期
                    if ((item.expidate < this.newDayTime) && item.expidate != '' && item.expidate != 0.5) {
                        item.expidate = "";
                        if (this.$refs.expidate && this.$refs.expidate[keys]) {
                            this.$refs.expidate[keys].$forceUpdate();
                        }
                        this.$message({
                            message: "失效日期不能小于今日",
                            type: "warning",
                        });
                    }

                    // 安全地进行数值计算，确保所有操作数都是有效的数字
                    const safePacknum = parseFloat(item.psodPacknum) || 0;
                    const safePrice = parseFloat(item.psprice) || 0;
                    const safeTaxPrice = parseFloat(item.psprice) || 0; // 假设含税单价就是psprice

                    // 计算含税金额
                    const calculatedPsmoney = NP.times(safeTaxPrice, safePacknum);
                    item.psmoney = this.$common.getDecimalInfo(3, isNaN(calculatedPsmoney) ? 0 : calculatedPsmoney);

                    // 计算金额
                    const safeUnitPrice = parseFloat(item.price) || 0; // 确保price字段存在
                    const calculatedMoney = NP.times(safeUnitPrice, safePacknum);
                    item.money = this.$common.getDecimalInfo(3, isNaN(calculatedMoney) ? 0 : calculatedMoney);

                    // 计算税额
                    const calculatedTax = NP.minus(parseFloat(item.psmoney) || 0, parseFloat(item.money) || 0);
                    this.$set(item, 'taxAmount', this.$common.getDecimalInfo(3, isNaN(calculatedTax) ? 0 : calculatedTax));

                    // 累计总金额和总数量（在同一次遍历中完成，避免额外的reduce操作）
                    const currentPsmoney = parseFloat(item.psmoney) || 0;
                    const currentPacknum = parseFloat(item.psodPacknum) || 0;

                    const totalMoneyResult = NP.plus(totalMoney, currentPsmoney);
                    totalMoney = isNaN(totalMoneyResult) ? totalMoney : totalMoneyResult;

                    const totalNumberResult = NP.plus(totalNumber, currentPacknum);
                    totalNumber = isNaN(totalNumberResult) ? totalNumber : totalNumberResult;
                });

                // 设置最终的总数和总金额
                this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, totalMoney);
                this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(1, totalNumber);
                this.sendDataInfo.totalCount = this.sendDataInfo.pisOrderDetail.length;
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        // 关闭弹窗
        closeExcel(val) {
            this.importShow = false
            if (val.list.length > 0) {
                var list = []
                val.list.forEach(item => {
                    list.push({})
                    for (const key in item) {
                        this.$set(list[list.length - 1], key, item[key])
                    }
                })
                this.sendDataInfo.pisOrderDetail.push(...list)
            }
        },
        clearBatchno(index) {
            var item = this.sendDataInfo.pisOrderDetail[index]
            if (item.batchno == "" && item.batchnoList && item.batchnoList.length > 0) {
                item.prodate = ""
                item.expidate = ""
                item.wesCodeList = []
            }
        },
        // 触发组件的提交
        fileSuccess(val) {
            {
                var list = []
                val.list.forEach(item => {
                    list.push({})
                    for (const key in item) {
                        this.$set(list[list.length - 1], key, item[key])
                    }
                })
                this.sendDataInfo.pisOrderDetail.push(...list)
            }
        },
        exportTemplate() {
            window.location.href = `${window.global_config.BASE_URL}/pisplanorder/downOneStepExcel`
        },
        importDetails() {
            this.$refs['sendDataInfo'].validate((valid) => {
                if (valid) {
                    this.importType = 'exportStepPisDetail'
                    this.url = 'pisplanorder/exportStepPisDetail'
                    this.importObj = {
                        formId: this.mxForm.jciId,
                        salesId: this.sendDataInfo.salesId,
                        unitId: this.sendDataInfo.smId,
                    }
                    this.importShow = true
                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            });
        },
        tabHeight(val) {
            this.mxHeight = val
        },
        resetData() {
            console.log(1212)
            this.$emit("drawerReset");
        },
        // 计算价格
        calculatePrice(cate = 1, index, flag) {
            var info = this.sendDataInfo.pisOrderDetail[index];

            // 输入验证
            if (info.psodPacknum <= 0) {
                this.$message({
                    message: "请先填写合理的采购数量",
                    type: "error",
                });
                return false;
            } else if (info.psodPacknum > info.saleableNum) {
                this.sendDataInfo.pisOrderDetail[index].psodPacknum = info.saleableNum;
                if (!flag) {
                    this.calculatePrice(cate, index, true);
                }
                this.$message({
                    message: "销售数量不能大于可销数量",
                    type: "error",
                });
                return;
            }

            this.sendDataInfo.pisOrderDetail.splice(1, 0);
            console.log(cate, 'cate');

            // 定义安全计算函数，遵循数值计算安全规范
            const safeParseFloat = (value) => parseFloat(value) || 0;
            const safeDivide = (dividend, divisor) => divisor === 0 ? 0 : NP.divide(dividend, divisor);
            const safeMultiply = (multiplicand, multiplier) => NP.times(multiplicand, multiplier);
            const calculateTaxFactor = (rate) => NP.plus(safeDivide(safeParseFloat(rate), 100), 1);

            // 定义计算方法，减少重复代码
            const calculateTaxedPrice = (price, rate) => this.$common.getDecimalInfo(2,
                NP.plus(price, safeDivide(safeMultiply(safeParseFloat(price), safeParseFloat(rate)), 100))
            );

            const calculateTaxedAmount = (unitPrice, quantity) => this.$common.getDecimalInfo(3,
                safeMultiply(safeParseFloat(unitPrice), safeParseFloat(quantity))
            );

            const calculatePreTaxAmount = (taxedAmount, rate) => this.$common.getDecimalInfo(3,
                safeDivide(safeParseFloat(taxedAmount), calculateTaxFactor(rate))
            );

            const calculateUnitPrice = (amount, quantity) => quantity === 0 ? 0 :
                this.$common.getDecimalInfo(2, safeDivide(safeParseFloat(amount), safeParseFloat(quantity)));

            // 根据不同类别计算价格
            switch (cate) {
                case 1: // 通过单价计算全部
                    // 计算含税价格
                    const taxedUnitPrice = calculateTaxedPrice(info.price, info.inRate);
                    this.sendDataInfo.pisOrderDetail[index].psprice = taxedUnitPrice;

                    // 计算金额
                    this.sendDataInfo.pisOrderDetail[index].money = calculateTaxedAmount(info.price, info.psodPacknum);

                    // 计算含税金额
                    this.sendDataInfo.pisOrderDetail[index].psmoney = calculateTaxedAmount(taxedUnitPrice, info.psodPacknum);

                    // 计算税额
                    this.sendDataInfo.pisOrderDetail[index].taxAmount = this.$common.getDecimalInfo(
                        3,
                        NP.minus(safeParseFloat(info.psmoney), safeParseFloat(info.money))
                    );
                    break;

                case 2: // 通过含税价格计算全部
                    // 计算含税金额
                    this.sendDataInfo.pisOrderDetail[index].psmoney = info.psodPacknum === 0 ? 0 :
                        calculateTaxedAmount(info.psprice, info.psodPacknum);

                    // 计算金额
                    const preTaxAmount = calculatePreTaxAmount(this.sendDataInfo.pisOrderDetail[index].psmoney, info.inRate);
                    this.sendDataInfo.pisOrderDetail[index].money = preTaxAmount;

                    // 计算单价
                    this.sendDataInfo.pisOrderDetail[index].price = calculateUnitPrice(preTaxAmount, info.psodPacknum);

                    // 计算税额
                    this.sendDataInfo.pisOrderDetail[index].taxAmount = this.$common.getDecimalInfo(
                        3,
                        NP.minus(safeParseFloat(info.psmoney), safeParseFloat(this.sendDataInfo.pisOrderDetail[index].money))
                    );
                    break;

                case 3: // 通过金额计算全部
                    // 计算单价
                    const unitPrice = calculateUnitPrice(info.money, info.psodPacknum);
                    this.sendDataInfo.pisOrderDetail[index].price = unitPrice;

                    // 计算含税价格
                    const taxedUnitPrice2 = calculateTaxedPrice(unitPrice, info.inRate);
                    this.sendDataInfo.pisOrderDetail[index].psprice = taxedUnitPrice2;

                    // 计算含税金额
                    this.sendDataInfo.pisOrderDetail[index].psmoney = calculateTaxedAmount(taxedUnitPrice2, info.psodPacknum);

                    // 计算税额
                    this.sendDataInfo.pisOrderDetail[index].taxAmount = this.$common.getDecimalInfo(
                        3,
                        NP.minus(safeParseFloat(info.psmoney), safeParseFloat(info.money))
                    );
                    break;

                case 4: // 通过含税金额计算全部
                    // 计算含税价格
                    this.sendDataInfo.pisOrderDetail[index].psprice = calculateUnitPrice(info.psmoney, info.psodPacknum);

                    // 计算金额
                    const preTaxTotal = calculatePreTaxAmount(info.psmoney, info.inRate);
                    this.sendDataInfo.pisOrderDetail[index].money = preTaxTotal;

                    // 计算单价
                    this.sendDataInfo.pisOrderDetail[index].price = calculateUnitPrice(preTaxTotal, info.psodPacknum);

                    // 计算税额
                    this.sendDataInfo.pisOrderDetail[index].taxAmount = this.$common.getDecimalInfo(
                        3,
                        NP.minus(safeParseFloat(info.psmoney), safeParseFloat(this.sendDataInfo.pisOrderDetail[index].money))
                    );
                    break;

                default: // 通过数量计算
                    // 计算含税金额
                    const calculatedPsmoney = info.psodPacknum === 0 ? 0 :
                        calculateTaxedAmount(info.psprice, info.psodPacknum);
                    this.sendDataInfo.pisOrderDetail[index].psmoney = calculatedPsmoney;
                    // 计算金额
                    const money = calculatePreTaxAmount(calculatedPsmoney, info.inRate);
                    this.sendDataInfo.pisOrderDetail[index].money = money
                    this.sendDataInfo.pisOrderDetail[index].price = calculateUnitPrice(money, info.psodPacknum);
                    // 计算整件数量
                    const safePackingSpec = safeParseFloat(info.packingSpec);
                    this.sendDataInfo.pisOrderDetail[index].wholeNum = Math.floor(
                        safeDivide(safeParseFloat(info.psodPacknum), safePackingSpec)
                    );

                    // 计算零散数量
                    this.sendDataInfo.pisOrderDetail[index].scatNum = NP.minus(
                        safeParseFloat(info.psodPacknum),
                        safeMultiply(safeParseFloat(info.wholeNum), safePackingSpec)
                    );

                    // 计算税额
                    this.sendDataInfo.pisOrderDetail[index].taxAmount = this.$common.getDecimalInfo(
                        3,
                        NP.minus(
                            safeParseFloat(this.sendDataInfo.pisOrderDetail[index].psmoney),
                            safeParseFloat(this.sendDataInfo.pisOrderDetail[index].money)
                        )
                    );

                    // 计算单价
                    this.sendDataInfo.pisOrderDetail[index].price = calculateUnitPrice(
                        this.sendDataInfo.pisOrderDetail[index].money,
                        info.psodPacknum
                    );

                    // 计算件数
                    this.sendDataInfo.pisOrderDetail[index].pieceNum = (safePackingSpec <= 0 || info.packingSpec == "")
                        ? 0
                        : this.$common.getDecimalInfo(1, safeDivide(safeParseFloat(info.psodPacknum), safePackingSpec));
                    break;
            }

            // 更新总计信息
            const moneyFour = this.sendDataInfo.pisOrderDetail[index].psmoney;
            this.sendDataInfo.totalMoney = moneyFour;
            this.sendDataInfo.totalCount = this.sendDataInfo.pisOrderDetail.length;

        },
        //新增明细
        addDetail(sendDataInfo) {
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    this.sendDataInfo.pisOrderDetail.push(
                        JSON.parse(JSON.stringify(this.detaislDataInfo))
                    );
                    this.$nextTick(() => {
                        this.selectedDetailsIndex = Number(
                            this.sendDataInfo.pisOrderDetail.length - 1
                        );
                        this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                        let refsElTable = this.$refs.mxTableRef;
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]
                        );
                    });
                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            });
        },
        // 检索Id, 索引(表格中), 标识
        //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
        openSearch(sId, index, type, sField, fField, flag) {
            if (type == "salesName") {
                if (this.sendDataInfo.smId == "") {
                    return this.$message({
                        message: "请先选择单位",
                        type: "warning",
                    });
                }
            }
            this.seIndex = index;
            if (flag) {
                this.detailsFlag = true
            } else {
                this.detailsFlag = false
            }
            if (type == "stName") {
                if (flag) {
                    this.parentSearchData.stName = this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex].stName;
                } else {
                    this.parentSearchData.stName = this.sendDataInfo.stName;
                }
            } else if (type == "psrgciTconmode" || type == 'psrgciTranmode') {
                this.parentSearchData[type] =
                    this.sendDataInfo.pisRegoCtri[type]
            } else if (type == 'regoName') {
                this.parentSearchData.opmBuyer = ''
                // this.parentSearchData.opmKeeper = 1
                this.parentSearchData.opmDelivery = 1
                this.parentSearchData.opmAcceptor = ''
            } else if (type == 'pschaName') {
                this.parentSearchData.opmBuyer = ''
                this.parentSearchData.opmAcceptor = 1
                this.parentSearchData.opmKeeper = ''
                this.parentSearchData.opmDelivery = ''
            }
            this.DialogVisible = true;
            this.seId = sId;
            this.seType = type;
            this.sField = sField
            this.fField = fField
            if (type == "bgmName") {
                this.parentSearchData.stId = this.sendDataInfo.stId;
                this.parentSearchData.cmId = this.sendDataInfo.cmId;
                this.parentSearchData.coId = this.sendDataInfo.coId;
                this.parentSearchData.orderType = this.sendDataInfo.orderType
                this.parentSearchData.bgmName =
                    this.sendDataInfo.pisOrderDetail[this.seIndex].bgmName;
                return;
            }
            this.parentSearchData[type] = this.sendDataInfo[type]
        },
        changeInputModel(val) {
            console.log(val, this.seType)
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                if (val.smId) this.parentSearchData.smId = val.smId
                if (this.seType == "bgmName") {
                    var bgiTypeArr = [];
                    var bgmIds = []
                    var repeatBgmId = []
                    this.sendDataInfo.pisOrderDetail.forEach((v) => {
                        if (v.bgmName != '' && v.bgmId != "") {
                            bgiTypeArr.push(v.bgiType);
                            repeatBgmId.push(v.bgmId);
                        }
                    });
                    if (val.length > 0) {
                        val.forEach(item => {
                            bgmIds.push(item.bgmId)
                            bgiTypeArr.push(item.bgiType)
                            repeatBgmId.push(item.bgmId);
                        })
                    } else {
                        bgiTypeArr[this.seIndex] = val.bgiType;
                        bgmIds = [val.bgmId]
                        repeatBgmId.push(val.bgmId);
                    }
                    this.$http
                        .checkPurchasingScope({
                            //校验明细商品
                            formId: this.mxForm.jciId, //表单ID
                            unitId: this.sendDataInfo.smId, //单位ID
                            bgmId: bgmIds, //商品id
                            // repeatBgmId: repeatBgmId,//重复商品id
                            ormId: JSON.parse(sessionStorage.getItem("loginInfo")).ormId, //组织ID
                            salesId: this.sendDataInfo.salesId, //对方业务员ID
                            bgiTypes: bgiTypeArr, //药品类型
                        })
                        .then((res) => {
                            if (res && res.status == 200) {

                                let flag = -1
                                if (res.result != null && res.result.length > 0) {
                                    this.dialogList = res.result
                                    flag = this.dialogList.findIndex(item => item.level == 0)
                                    this.showDialog = true
                                }
                                if (flag == -1) {
                                    if (val.length > 0) {
                                        this.bgmSelect(val)
                                        return
                                    }
                                    for (let key in val) {
                                        this.sendDataInfo.pisOrderDetail[this.seIndex][key] =
                                            val[key];
                                    }
                                    this.sendDataInfo.pisOrderDetail[this.seIndex].psodPsdvolume = val.rjXl;
                                    this.sendDataInfo.pisOrderDetail[this.seIndex].psodPsnvolume = val.stockNum;
                                    this.sendDataInfo.pisOrderDetail[this.seIndex].psodPsupperlimit = val.limdHighnum;
                                    this.sendDataInfo.pisOrderDetail[this.seIndex].psodPslowerlimit = val.limdLownum;
                                    if (this.sendDataInfo.stName && this.sendDataInfo.stId && this.sendDataInfo.stName != "" && this.sendDataInfo.stId != "") {
                                        this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'stName', this.sendDataInfo.stName);
                                        this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'stId', this.sendDataInfo.stId);
                                    }
                                    this.batchSelect(this.seIndex).then(() => {
                                        this.$nextTick(() => {
                                            this.tableNextFocus(this.fField, this.seIndex);
                                        });
                                    });
                                } else {
                                    this.showDialog = true
                                }
                            } else {
                                this.lineMessageBox(res);
                                this.$set(
                                    this.sendDataInfo.pisOrderDetail,
                                    this.seIndex,
                                    JSON.parse(JSON.stringify(this.detaislDataInfo))
                                );
                                if (this.sendDataInfo.stName && this.sendDataInfo.stId && this.sendDataInfo.stName != "" && this.sendDataInfo.stId != "") {
                                    this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'stName', this.sendDataInfo.stName);
                                    this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'stId', this.sendDataInfo.stId);
                                }
                                return false;
                            }
                        })
                        .catch((rej) => {
                            this.lineMessageBox(rej);
                            for (let key in this.sendDataInfo.pisOrderDetail[this.seIndex]) {
                                this.sendDataInfo.pisOrderDetail[this.seIndex][key] = "";
                            }
                            if (this.sendDataInfo.stName && this.sendDataInfo.stId && this.sendDataInfo.stName != "" && this.sendDataInfo.stId != "") {
                                this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'stName', this.sendDataInfo.stName);
                                this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'stId', this.sendDataInfo.stId);
                            }
                        });
                } else if (this.seType == "smName") {
                    this.$http.checkVendorLicense({
                        //校验购进单位
                        formId: this.formDataList[0].jciId, //表单ID
                        unitId: val.smId, //单位ID
                    }).then((res) => {
                        if (res && res.status == 200) {
                            let flag = -1
                            if (res.result != null && res.result.length > 0) {
                                this.dialogList = res.result
                                flag = this.dialogList.findIndex(item => item.level == 0)
                                this.showDialog = true
                            }
                            if (flag == -1) {
                                this.parentSearchData.smId = val.smId;
                                this.sendDataInfo.smName = val.smName;
                                this.sendDataInfo.smId = val.smId;
                                this.$http.queryDefaultSales({
                                    ids: [val.smId]
                                }).then((res) => {
                                    if (res && res.status == 200) {
                                        var valObj = {
                                            ...val,
                                            ...res.result,
                                        }
                                        if (valObj.salesId && valObj.salesName && this.sField.indexOf('salesId') != -1 && this.sField.indexOf('salesName') != -1) {
                                            this.$http.checkSalesLicense({
                                                //校验供应商业务员
                                                formId: this.formDataList[0].jciId, //表单ID
                                                salesId: valObj.salesId, //业务员ID
                                            }).then((res) => {
                                                if (res && res.status == 200) {
                                                    let flag = -1;
                                                    if (res.result != null && res.result.length > 0) {
                                                        res.result.forEach(item => {
                                                            this.dialogList.push(item)
                                                        })
                                                        flag = this.dialogList.findIndex(
                                                            (item) => item.level == 0
                                                        );
                                                        this.showDialog = true;
                                                    }
                                                    if (flag == -1) {
                                                        this.paramValue(valObj);
                                                    }
                                                } else {
                                                    this.lineMessageBox(res);

                                                    return false;
                                                }
                                            }).catch((rej) => {
                                                this.lineMessageBox(rej);
                                            });
                                        } else {
                                            this.paramValue(val);
                                        }
                                    } else {
                                        this.paramValue(val);
                                    }
                                }).catch((rej) => {
                                    this.lineMessageBox(rej);
                                });
                            } else {
                                this.showDialog = true
                            }

                        } else {
                            this.lineMessageBox(res);
                            this.parentSearchData.smId = "";
                            this.clearValue();
                            return false;
                        }
                    }).catch((rej) => {
                        this.lineMessageBox(rej);
                        this.parentSearchData.smId = "";
                        this.clearValue();
                    });
                } else if (this.seType == "salesName") {
                    this.$http.checkSalesLicense({
                        //校验供应商业务员
                        formId: this.formDataList[0].jciId, //表单ID
                        salesId: val.salesId, //业务员ID
                    }).then((res) => {
                        if (res && res.status == 200) {
                            let flag = -1
                            this.dialogList = []
                            if (res.result != null && res.result.length > 0) {
                                this.dialogList = res.result
                                flag = this.dialogList.findIndex(item => item.level == 0)
                                this.showDialog = true
                            }
                            if (flag == -1) {
                                this.paramValue(val);
                            } else {
                                this.showDialog = true
                            }
                        } else {
                            this.lineMessageBox(res);
                            this.clearValue();
                            return false;
                        }
                    })
                        .catch((rej) => {
                            this.lineMessageBox(rej);

                            this.clearValue();
                        });
                } else if (this.seType == "stName") {
                    if (this.detailsFlag) {
                        this.mxParamValue(val);
                    } else {
                        this.paramValue(val);
                        if (this.sendDataInfo.pisOrderDetail.length > 0) {
                            this.sendDataInfo.pisOrderDetail.forEach(item => {
                                item.stName = val.stName
                                item.stId = val.stId
                            })
                        } else {
                            this.$nextTick(() => {
                                this.nextFocus(this.seIndex);
                            });
                        }
                    }
                } else if (this.seType == "coName") {
                    this.paramValue(val);
                    this.parentSearchData.coId = val.coId;
                } else if (this.seType == "psrgciTranmode" || this.seType == "psrgciTconmode") {
                    this.sendDataInfo.pisRegoCtri[this.seType] = val[this.seType]
                } else {
                    this.paramValue(val);
                }
            }
        },
        bgmSelect(val) {
            // 创建mx数组副本并设置默认值
            const mx = val.map(item => ({
                ...item,
                psodPsnvolume: item.stockNum || 0,
                psodPsdvolume: item.rjXl || 0,
                psodPsupperlimit: item.limdHighnum || 0,
                psodPslowerlimit: item.limdLownum || 0,
            }));

            // 过滤掉bgmId或bgmName为空的条目
            this.sendDataInfo.pisOrderDetail = this.sendDataInfo.pisOrderDetail.filter(
                item => item.bgmId && item.bgmName
            );

            // 合并处理逻辑，消除重复代码
            const processItem = (item) => {
                const processedItem = { ...this.detaislDataInfo, ...item };

                // 设置仓库信息（如果存在）
                if (this.sendDataInfo.stName && this.sendDataInfo.stId &&
                    this.sendDataInfo.stName !== "" && this.sendDataInfo.stId !== "") {
                    processedItem.stName = this.sendDataInfo.stName;
                    processedItem.stId = this.sendDataInfo.stId;
                }

                return processedItem;
            };

            // 根据是否已有订单明细决定如何处理
            if (this.sendDataInfo.pisOrderDetail && this.sendDataInfo.pisOrderDetail.length > 0) {
                // 将mx中的数据添加到现有订单明细中
                const newItems = mx.map(processItem);
                this.sendDataInfo.pisOrderDetail.push(...newItems);
            } else {
                // 如果没有现有订单明细，直接创建新数组
                this.sendDataInfo.pisOrderDetail = mx.map(processItem);
            }

            // 更新选中的明细索引
            this.selectedDetailsIndex = this.sendDataInfo.pisOrderDetail.length - 1;
        },
        async batchSelect(index) {
            var info = this.sendDataInfo.pisOrderDetail[index]
            info.batchnoList = []
            info.wesCodeList = []
            const res = await this.$http.pisplanorderwesDetailQuery({
                bgmId: info.bgmId,
                bgmName: info.bgmName,
                manufacturer: info.manufacturer || "",
                smName: this.sendDataInfo.smName,
                psomBuyDate: this.sendDataInfo.psomBuydate,
            })
            console.log(res)
            if (res.status == 200) {
                
                info.batchnoList.push(...res.result)
                this.$nextTick(() => {
                    this.tableIndex++
                })
            }
        },
        openSearchs(batchnoList, index) {
            this.batchnoList = batchnoList
            this.seIndex = index
            this.selectedDetailsIndex = index
            var info = this.sendDataInfo.pisOrderDetail[index]
            var list = this.sendDataInfo.pisOrderDetail.filter(item => item.bgmId == info.bgmId)
            this.selectDataList = info.wesCodeList
            var dataList = list.filter(item => item.batchnoList.length > 0 && item.wesCodeList.length > 0)
            this.dataList = []
            dataList.forEach(item => {
                this.dataList.push(...item.wesCodeList)
            })
            this.batchnoShow = true
        },
        TranData(val) {
            console.log(val);
            if (val != "" || val != undefined) {
                this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'batchno', val.batchno)
                this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'prodate', val.prodate)
                this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'expidate', val.expidate)
                this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'batchno1', val.batchno)
                this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'prodate1', val.prodate)
                this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'expidate1', val.expidate)
                this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'wesCodeList', val.wesCodeList)
                this.$set(this.sendDataInfo.pisOrderDetail[this.seIndex], 'psodPacknum', val.num || 0)
                this.calculatePrice(5, this.seIndex)
            }
            this.batchnoShow = false
        },
        // 判断是不是采购员
        checkIsBuyer() {
            if (this.dataActionBox.actionType != 0) return;
            let info = JSON.parse(sessionStorage.getItem("userInfo"));
            if (info.opmBuyer == 1) {
                this.isBuyer = 1;
                this.sendDataInfo.depName = info.depName;
                this.sendDataInfo.depId = info.depId;
                this.sendDataInfo.opmName = info.opmName;
                this.sendDataInfo.opmId = info.opmId;
            }
        },
        // 表格赋值字段
        // 表格赋值字段
        mxParamValue(val) {
            console.log(this.sField)
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                console.log(item)
                this.sendDataInfo.pisOrderDetail[this.seIndex][item] = val[item];
            });
            this.$nextTick(() => {
                this.tableNextFocus(this.fField, this.seIndex)
            })
            this.sendDataInfo.pisOrderDetail.splice(1, 0)
        },
        //换行提示
        lineMessageBox(data) {
            let txtArr = data.message.split("<br/>");
            let newArr = [];
            const h = this.$createElement;
            for (const i in txtArr) {
                newArr.push(h("p", null, txtArr[i]));
            }
            this.$alert(h("div", null, newArr), "提示", {
                confirmButtonText: "确定",
                callback: (action) => { },
            });
        },
        // 不可赋值字段
        noSetField(val) {
            let arr = this.nosField.split(',')
            arr.forEach(item => {
                this.sendDataInfo[item] = ''
            })
        },

        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.sendDataInfo[item] = val[item]
            })
            this.$nextTick(() => {
                this.nextFocus(this.seIndex)
            })
        },

        // 清除赋值字段数据
        clearValue() {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.sendDataInfo[item] = ''
            })
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        // 获取冷链表单所有input
        getMainInput() {
            var el = document.getElementById('mainInfo')
            if (el) this.inputel = el.getElementsByTagName('input')
        },

        // 主表单select框切换enter切换焦点事件方法
        selectChange(e) {
            if (e == false) {
                for (let index = 0; index < this.inputel.length; index++) {
                    if (this.inputel[index] == document.activeElement) {
                        this.nextFocus(index)
                        break
                    }
                }
            }
        },
        closeChild() {
            addEventListener('keyup', this.keyUp)//创建监听键盘事件
        },
        // 输入框切换焦点
        nextFocus(index) {
            if (index >= (this.inputel.length - 1)) {
                if (this.sendDataInfo.pisOrderDetail.length > 0) {
                    this.tableNextFocus('bgmName', 0)
                }
                this.addDetail("sendDataInfo");
                return;
            }
            var aindex = index + 1
            if (this.inputel[aindex].value != '' || this.inputel[aindex].disabled) {
                this.nextFocus(aindex)
                return
            }
            this.inputel[aindex].focus()
        },
        // 时间框失去焦点
        timeBlur(index) {
            this.nextFocus(index)
        },
        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == '') {
                    this.inputel[index].focus()
                    break
                }
            }
        },

        // 表格切换焦点方法
        tableNextFocus(field, index) {
            console.log(field, index)
            if (field == "prodate") {
                let ine = document
                    .getElementsByClassName("prodate")[index].getElementsByTagName("input")[0];
                ine.focus();
                return;
            } else if (field == "expidate") {
                let ine = document
                    .getElementsByClassName("expidate")[index].getElementsByTagName("input")[0];
                ine.focus();
                return;
            }
            if (field == "keydown") {
                if (this.sendDataInfo.pisOrderDetail[index + 1] != undefined) {
                    this.$refs["bgmName"][index + 1].focus();
                    return;
                }
                var flag = false
                this.mxForm.jurconfigform.forEach(item => {
                    if (item.entityField == "expidate" || item.entityField == 'prodate') {
                        if (this.sendDataInfo.pisOrderDetail[this.seIndex].prodate != 0.5 && this.sendDataInfo.pisOrderDetail[this.seIndex].prodate != "" && this.sendDataInfo.pisOrderDetail[this.seIndex].prodate > new Date().getTime()) {
                            if (document.getElementsByClassName('el-message').length == 0) {
                                this.$message({
                                    message: "生产日期不能大于今天",
                                    type: "warning",
                                });
                            }
                            return flag = true
                        }
                        if (this.sendDataInfo.pisOrderDetail[this.seIndex].expidate != 0.5 && this.sendDataInfo.pisOrderDetail[this.seIndex].expidate != "" && this.sendDataInfo.pisOrderDetail[this.seIndex].expidate < new Date().getTime()) {
                            if (document.getElementsByClassName('el-message').length == 0) {
                                this.$message({
                                    message: "有效期不能小于今天",
                                    type: "warning",
                                });
                            }
                            return flag = true
                        }

                    }
                })
                if (flag) {
                    return
                }
                this.addDetail("sendDataInfo");
                return;
            }
            this.$refs[field][index].focus()
        },

        // 监听键盘事件
        keyUp(e) {
            if (e.key == 'F1') { // 右键新增明细
                e.preventDefault();
                // this.addDetail('sendDataInfo')
                return
            } else if (e.key == 'F2') {
                e.preventDefault();
                this.deleteDetails()
            } else if (e.key == "F4" && this.dataActionBox.actionType != 2) {//保存
                this.sendDataAction('sendDataInfo')
            } else if (e.keyCode == 40) { // 下键
                // 表格为空，不执行下方 
                if (this.sendDataInfo.pisOrderDetail.length == 0) return
                let refsElTable = this.$refs.mxTableRef
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 如果当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0
                    } else if (this.selectedDetailsIndex == this.sendDataInfo.pisOrderDetail.length - 1) { // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedDetailsIndex = 0
                    } else { // 正常递增
                        this.selectedDetailsIndex++
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex], false);
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]); // 把现在当前行勾选
                })
            } else if (e.keyCode == 38) { // 上键
                if (this.sendDataInfo.pisOrderDetail.length == 0) return
                let refsElTable = this.$refs.mxTableRef
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0
                    } else if (this.selectedDetailsIndex == 0) { // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedDetailsIndex = this.sendDataInfo.pisOrderDetail.length - 1
                    } else { // 正常递减
                        this.selectedDetailsIndex--
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedDetailsIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex], false);
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]); // 把现在当前行勾选
                })
            }

        },

        // 表格方法
        rowClassName({ row, rowIndex }) {
            let rowName = "",
                findRow = this.selectedRow.find(c => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },

        // 选中行底色逻辑
        rowStyle({ row, rowIndex }) {
            Object.defineProperty(row, "rowIndex", { // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false
            });
            let rowBackground = {}
            if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
            return rowBackground
        },

        // 明细表格点击选中
        clickEvent(row, column, event, params) {
            let refsElTable = this.$refs.mxTableRef; // 获取表格对象
            let findRow = {}
            this.selectedDetailsIndex = row.rowIndex
            findRow = this.selectedRow.find(c => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },

        // 保存已选择行
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },


        showPrintPlan() { // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData.printJurId)
            } else {
                return
            }
        },
        // 子组件穿透
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2) this.$parent.$parent.toDetail(orderId)
            else this.$parent.$parent.$parent.toDetail(orderId)
        },
        deleteDetails() {
            if (this.sendDataInfo.pisOrderDetail.length < 1) {
                return this.$message({
                    message: "暂无可删除明细",
                    type: "warning",
                });
            }

            // this.sendDataInfo.pisOrderDetail.splice(this.selectedDetailsIndex, 1);
            // this.selectedDetailsIndex = 0;

            this.sendDataInfo.pisOrderDetail.splice(this.selectedDetailsIndex, 1);
            if (this.sendDataInfo.pisOrderDetail.length > 1) {
                this.selectedDetailsIndex = Number(this.selectedDetailsIndex - 1);
            } else {
                this.selectedDetailsIndex = 0;
            }
            this.tableNextFocus("bgmName", this.selectedDetailsIndex);
            let refsElTable = this.$refs.mxTableRef;
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(
                this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]
            );
        },
        // 触发提取方案
        openExComponents(e) {
            this.exId = e;
            this.ppId = e == '3405885795012608' ? 'psomId' : 'orderId'
            this.DialogExtract = true;
            removeEventListener('keyup', this.keyUp)
        },
        // 获取 提取单数据
        async getExData(val) {
            this.ppIds = this.exId == '3405885795012608' ? 'psomId' : 'orderId'
            for (let key in val) {
                if (key == "arrlistbychen") {
                    this.sendDataInfo.pisOrderDetail = val.arrlistbychen;
                    this.sendDataInfo.pisOrderDetail.forEach(item => {
                        this.$set(item, 'batchnoList', [])
                        this.$set(item, 'wesCodeList', [])
                    })
                } else {
                    this.sendDataInfo[key] = val[key];
                }
            }
            if (!val.salesName || !val.salesId || !val.recName || !val.recId) {
                this.$http.queryDefaultSales({
                    ids: [val.smId]
                }).then((res) => {
                    if (res && res.status == 200) {
                        for (const key in res.result) {
                            if (!this.sendDataInfo[key]) {
                                this.sendDataInfo[key] = res.result[key] || "";
                            }
                        }
                    }
                })
            }
            this.DialogExtract = false;
            addEventListener('keyup', this.keyUp)//创建监听键盘事件
            this.DialogExtract = false;
            if (this.ppId == 'psomId') {
                this.tabForm[0].jurconfigform.forEach(item => {
                    if (item.entityField != 'regoName' && item.entityField != 'pschaName') {
                        item.isChange = 0
                    }
                })
                this.mxForm.jurconfigform.forEach(item => {
                    if (item.entityField != 'sterBatchno' && item.entityField != 'batchno' && item.entityField != 'prodate' && item.entityField != 'expidate') {
                        item.isChange = 0
                    }
                })
                this.$nextTick(() => {
                    this.initFocus()
                })
                return
            }
            this.$nextTick(() => {
                this.selectedDetailsIndex = 0
                this.tableNextFocus('psodPacknum', 0)
                let refsElTable = this.$refs.mxTableRef
                refsElTable.clearSelection();
                refsElTable.toggleRowSelection(this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]);
            })
        },
        //匹配商品
        async matchingClick() {
            var arr = this.sendDataInfo.pisOrderDetail.filter(item => item.detailId)
            if (arr.length == 0) {
                return this.$message({
                    message: "请选择要匹配的明细",
                    type: "warning",
                });
            }
            const params = arr.map(item => {
                return {
                    detailId: item.detailId,
                    bgmId: item.bgmId,
                    bgmName: item.bgmName,
                    manufacturer: item.manufacturer,
                    smName: this.sendDataInfo.smName,
                    psomBuyDate: this.sendDataInfo.psomBuydate,
                }
            })
            let res = await this.$http.pisplanordermatchWesDetail(params)
            if (res && res.status == 200) {
                this.sendDataInfo.pisOrderDetail.forEach((item, keys) => {
                    var arr1 = res.result.filter(c => c.detailId == item.detailId)
                    if (arr1.length > 0) {
                        item.batchnoList = arr1[0].wesBatchList
                    } else {
                        item.batchnoList = []
                    }
                    this.$set(item, 'wesCodeList', [])
                })
                this.$nextTick(() => {
                    this.tableIndex++
                })
                this.$message({
                    message: "匹配成功",
                    type: "success",
                });
            }
        },
        getExWidth(e) {
            this.exWidth = e + "%";
        },
        getExtractName(e) {
            this.exTitle = e;
        },
        handleDrawerClose(done) {
            this.$confirm("确认关闭？")
                .then((_) => {
                    done();
                })
                .catch((_) => { });
        },

        // 计算价格
        computerPrice(cate, index) {
            // 修改数量/单价/税率
            if (cate == 1) {
                this.sendDataInfo.totalNumber = 0;
                this.sendDataInfo.totalMoney = 0;
                this.sendDataInfo.pisOrderDetail.forEach((item, keys) => {

                    // 含税金额
                    item.psmoney = this.$common.getDecimalInfo(3, NP.times(item.psprice, item.psodPacknum))
                    // 金额
                    item.money = this.$common.getDecimalInfo(3, NP.times(item.price, item.psodPacknum))

                    // 计算整件数量
                    this.sendDataInfo.pisOrderDetail[keys].wholeNum = Math.floor(item.psodPacknum / Number(item.packingSpec))

                    //计算零散数量
                    this.sendDataInfo.pisOrderDetail[keys].scatNum = item.psodPacknum - item.wholeNum * Number(item.packingSpec)

                    //计算税额
                    this.sendDataInfo.pisOrderDetail[keys].taxAmount = this.$common.getDecimalInfo(3, NP.minus(item.psmoney, item.money))

                    // 计算件数 采数/包装单位
                    if (parseFloat(item.packingSpec) <= 0 || item.packingSpec == "") {
                        this.sendDataInfo.pisOrderDetail[keys].pieceNum = 0;
                    } else {
                        this.sendDataInfo.pisOrderDetail[keys].pieceNum =
                            this.$common.getDecimalInfo(
                                1,
                                NP.divide(item.psodPacknum, item.packingSpec)
                            );
                    }
                    this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, NP.plus(this.sendDataInfo.totalMoney, item.psmoney))
                    this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(1, NP.plus(this.sendDataInfo.totalNumber, item.psodPacknum))
                });
                this.sendDataInfo.totalCount = this.sendDataInfo.pisOrderDetail.length;
            }
        },
        sendDataAction(formName) {
            // console.log(formName);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // console.log(valid);
                    this.sub();
                } else {
                    return false;
                }
            });
        },
        async sub() {
            if (this.sendDataInfo.pisOrderDetail.length < 1) {
                this.$message({
                    message: "请添加采购明细",
                    type: "error",
                });
                return;
            } else {
                this.sendDataInfo.pisOrderDetail.forEach((item, index) => {
                    if (item.bgmId == "") {
                        this.sendDataInfo.pisOrderDetail.splice(index, 1);
                    }
                    if (item.wesCodeList && item.wesCodeList.length > 0) {
                        item.wesCode = item.wesCodeList.map(c => c.wesCode).join(',')
                    }
                });
            }

            var flagNum = false
            var flag1 = false
            var indexNum = 0
            var indexNum1 = 0
            this.sendDataInfo.pisOrderDetail.forEach((item, index) => {
                if ((item.psodPacknum == "" || item.psodPacknum == null || item.psodPacknum <= 0) && !flagNum) {
                    indexNum1 = index
                    flagNum = true
                }
                if ((item.psprice == "" || item.psprice == null || item.psprice <= 0) && (item.psmoney == "" || item.psmoney == null || item.psmoney <= 0) && (item.price == "" || item.price == null || item.price <= 0) && (item.money == "" || item.money == null || item.money <= 0)) {

                } else if (item.psprice > 0 && item.psmoney > 0 && item.price > 0 && item.money > 0) {

                } else if (!flag1) {
                    indexNum = index
                    flag1 = true
                }
            })
            if (flagNum) {
                return this.$message.error(`第${indexNum1 + 1}行的${this.sendDataInfo.pisOrderDetail[indexNum1].bgmName}数量不能为空或为零！`)
            }
            if (flag1) {
                return this.$message.error(`第${indexNum + 1}行的${this.sendDataInfo.pisOrderDetail[indexNum].bgmName}（含税价格、含税金额、价格、金额）有为零的请检查！`)
            }
            var flag = true
            for (let i = 0; i < this.sendDataInfo.pisOrderDetail.length; i++) {
                let ele = this.sendDataInfo.pisOrderDetail[i]
                for (let index = 0; index < this.mxForm.jurconfigform.length; index++) {
                    let formEle = this.mxForm.jurconfigform[index]
                    console.log(ele[formEle.entityField], formEle.isRequired)
                    if ((ele[formEle.entityField] && ele[formEle.entityField].length == 0
                        || ele[formEle.entityField] == null) && formEle.isRequired == 1

                    ) {
                        this.$message({
                            type: "error",
                            message: "明细商品第" + (i + 1) + '行数据中的' + formEle.chineseField + '不能为空',
                        });
                        flag = false
                        break;
                    }
                    if ((ele[formEle.entityField] && ele[formEle.entityField].length == 0
                        || ele[formEle.entityField] == null) && formEle.isRequired == 1

                    ) {
                        this.$message({
                            type: "error",
                            message: "明细商品第" + (i + 1) + '行数据中的' + formEle.chineseField + '不能为空',
                        });
                        flag = false
                        break;
                    }
                }
                if (!flag) {

                    break;
                }
            }
            if (!flag) return
            this.sendDataInfo.totalCount = this.sendDataInfo.pisOrderDetail.length
            this.sendDataInfo.pisOrderDetail.forEach((item, index) => {
                if (item.batchnoList && item.batchnoList.length > 0) {
                    if (item.batchno != item.batchno1 || item.prodate != item.prodate1 || item.expidate != item.expidate1) {
                        item.wesCodeList = []
                    }
                }
            })
            if (this.dataActionBox.actionType == 0) {
                var responseData = await this.$http.puOneWarehousingAdd(this.sendDataInfo);
            } else {
                var responseData = await this.$http.setPurchaseOrder(this.sendDataInfo);
            }
            if (responseData.status == 200) {

                this.init();

                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$emit("drawerCancel", { refresh: 1, id: responseData.result });
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        initActionBox(sendDataInfo) {
            this.$confirm('确定取消' + this.dataActionBox.boxTitle + '吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$common.delOrderInfo(this.sendDataInfo.psomId)
                this.$emit('drawerCancel', 0)
                this.init()
                this.$refs[sendDataInfo].resetFields();
            }).catch(() => { });
        },
        init() {
            for (let key in this.sendDataInfo) {
                if (key == "pisRegoCtri") {
                    for (let sonOne in this.sendDataInfo[key]) {
                        this.sendDataInfo[key][sonOne] = "";
                    }
                } else if (key == "pisOrderDetail") {
                    this.sendDataInfo[key] = [];
                } else {
                    this.sendDataInfo[key] = "";
                }
            }
            this.sendDataInfo.psomBuydate = this.$moment().valueOf();
            this.sendDataInfo.isWms = Number(this.sendDataInfo.isWms)
            this.sendDataInfo.isMag = Number(this.sendDataInfo.isMag)
            this.sendDataInfo.totalMoney = 0;
            this.sendDataInfo.totalNumber = 0;
            this.sendDataInfo.totalCount = 0;
        },
        // 提取采购订单
        async selectDataAction(data) {
            if (data) {
                var sendData = data;
                let responseData = await this.$http.extractPurchaseOrder({
                    ids: sendData,
                });
                console.log(responseData);
                if (responseData.status == 200) {
                    this.sendDataInfo = responseData.result;
                    this.sendDataInfo.psrgmRedate = this.$moment().valueOf();
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            }
        },
        // 保存草稿 - 打开弹窗
        saveDraft() {
            // 重置表单
            this.draftForm.remark = "";
            // 打开弹窗
            this.draftDialogVisible = true;
            // 聚焦到备注输入框
            this.$nextTick(() => {
                if (this.$refs.draftForm) {
                    this.$refs.draftForm.clearValidate();
                }
            });
        },

        // 确认保存草稿
        async confirmSaveDraft() {
            // 表单验证
            this.$refs.draftForm.validate(async (valid) => {
                if (valid) {
                    try {
                        // 准备保存的数据
                        const draftData = {
                            remark: this.draftForm.remark,
                            jsonContent: JSON.stringify(this.sendDataInfo), // 将sendDataInfo转为JSON字符串
                            modelType: '采购入库一步'
                        };

                        console.log("保存草稿数据:", draftData);

                        // 调用保存草稿接口
                        const response = await this.$http.draftAddDraft(draftData);

                        if (response.status === 200) {
                            this.$message.success("草稿保存成功");
                            this.draftDialogVisible = false;
                            this.init();
                        } else {
                            this.$message.error(response.message || "草稿保存失败");
                        }
                    } catch (error) {
                        console.error("保存草稿失败:", error);
                        this.$message.error("草稿保存失败，请重试");
                    }
                }
            });
        },

        // 提取草稿 - 打开草稿列表弹窗
        async draft() {
            try {
                // 打开弹窗
                this.draftListDialogVisible = true;
                // 加载草稿列表
                await this.loadDraftList();
            } catch (error) {
                console.error("打开草稿列表失败:", error);
                this.$message.error("打开草稿列表失败");
            }
        },

        // 加载草稿列表
        async loadDraftList() {
            this.loadingDraftList = true;
            try {
                const response = await this.$http.draftGetList({
                    type: '采购入库一步',
                    page: 1,
                    rows: 1000,
                });

                if (response.status === 200) {
                    this.draftList = response.result || [];
                    this.selectedDraftIndex = -1;
                } else {
                    this.$message.error(response.message || "获取草稿列表失败");
                    this.draftList = [];
                }
            } catch (error) {
                console.error("获取草稿列表失败:", error);
                this.$message.error("获取草稿列表失败，请重试");
                this.draftList = [];
            } finally {
                this.loadingDraftList = false;
            }
        },

        // 草稿行点击事件
        onDraftRowClick(row, column, event) {
            const index = this.draftList.findIndex(item => item.id === row.id);
            this.selectedDraftIndex = index;
        },

        // 获取草稿行样式类名
        getDraftRowClassName({ row, rowIndex }) {
            if (rowIndex === this.selectedDraftIndex) {
                return 'selected-draft-row';
            }
            return '';
        },

        // 加载草稿数据
        async loadDraft(draftItem) {
            try {
                // 确认加载草稿
                const confirmResult = await this.$confirm(
                    `确定要加载草稿"${draftItem.remark}"吗？当前未保存的数据将会丢失。`,
                    '确认加载草稿',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }
                );

                if (confirmResult) {
                    // 解析草稿数据
                    const draftData = JSON.parse(draftItem.jsonContent);

                    // 加载数据到sendDataInfo
                    this.sendDataInfo = { ...this.sendDataInfo, ...draftData };

                    // 关闭弹窗
                    this.draftListDialogVisible = false;
                    this.$http.draftDelById({
                        ids: [draftItem.id]
                    })
                    this.$message.success("草稿加载成功");
                }
            } catch (error) {
                console.error("加载草稿失败:", error);
                this.$message.error("加载草稿失败，请重试");
            }
        },

        // 删除草稿
        async deleteDraft(draftItem, index) {

        },

        openBox() {
            this.dataActionBox.actionType = this.actionData.cate
            this.formDataList = JSON.parse(JSON.stringify(this.actionData.formData))
            var oldData = this.actionData.oldData
            this.showTabs = this.actionData.formData[0].jciName
            this.filterMainField()
            this.getTimestamp()
            // this.init();
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
                this.sendDataInfo.psrgmRedate = this.$moment().valueOf();
            } else if (this.dataActionBox.actionType == 1) {
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                for (let key in oldData) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
                this.$nextTick(() => {
                    if (this.sendDataInfo.pisOrderDetail.length > 0)
                        this.selectedDetailsIndex = 0
                    let refsElTable = this.$refs.mxTableRef
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.sendDataInfo.pisOrderDetail[this.selectedDetailsIndex]);
                })
            } else {
                this.dataActionBox.boxTitle = '查看信息'
                var dataInfo = JSON.parse(JSON.stringify(oldData))
                for (let key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key])
                }
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.mxHeight = this.$common.getHeight()
                    }
                    this.initFocus()
                }, 16.7)
                //(data中需要定义mxHeight,230可以根据明细表格有无操作按钮进行调整)
            })
        },
        getTimestamp() {
            this.newTime = this.$common.getEndTime()
            this.newDayTime = this.$common.getNewDayTime()
        },
        // 过滤表单不同类型
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item));
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1)
                        this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
                }
            });
            console.log(this.tabForm, "测试");

            var arr = [{ entityField: "pisOrderDetail" }]
            var obj = this.$common.filterMainFields(this.formDataList, arr, mainFormList[0])
            var obj1 = this.$common.filterMainFields(this.formDataList, [], mainFormList[1])
            console.log(obj1, "测试123");

            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
            this.$set(this.sendDataInfo, "pisRegoCtri", {})
            for (let key in obj1) {
                this.$set(this.sendDataInfo.pisRegoCtri, key, obj1[key])
            }
            this.$set(this.sendDataInfo, "psomBuydate", this.$moment().valueOf())
            this.sendDataInfo.totalMoney = 0;
            this.sendDataInfo.totalNumber = 0;
            this.sendDataInfo.totalCount = 0;
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox()
            this.checkIsBuyer();
        })
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        document.onkeydown = function () {
            if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                window.event.returnValue = false;
            }
        };

        addEventListener('keyup', this.keyUp)//创建监听键盘事件

    },
    //生命周期 - 销毁之前
    beforeDestroy() {
        removeEventListener('keyup', this.keyUp)
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput()
    }, //生命周期 - 更新之后
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}

.formbot {
    display: flex;
    flex-direction: row;
    justify-content: center;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    /* padding-right: 20px; */
}

.mb {
    margin-bottom: 0;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
    width: 100%;
}

::v-deep .stIdSelect {
    height: auto;
}

/* 草稿列表选中行样式 */
::v-deep .selected-draft-row {
    background-color: #ecf5ff !important;
}

::v-deep .selected-draft-row:hover {
    background-color: #ecf5ff !important;
}
</style>
<style>
.el-table .rowStyle {
    background: #fff7ca !important;
}
</style>